import { set, keyBy } from 'lodash/fp';
import createReducer from '../../../helpers/createReducer';
import { fetchClientColumns } from '../../sagas/client/routines';

const initialState = {
  columnsByName: {},
  fetchedColumns: false,
  fetchingColumns: false,
  fetchingColumnsError: null,
  updating: false,
  saving: false,
  saveError: null,
  updateError: null
};

export const fetchClientColumnsHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    fetchingColumns: true,
    fetchedColumns: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set(`columnsByName`, keyBy('name', response.items), state),
  [routine.FAILURE]: (state, { error }) =>
    set('fetchingColumnsError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetchingColumns: false,
    fetchedColumns: true
  })
});

export default createReducer(initialState, {
  ...fetchClientColumnsHandler(fetchClientColumns)
});
